export default __webpack_public_path__ + "static/media/Bottom Navigation.b16124c3.svg";